import { ReactNode } from 'react'

import { useTranslation } from 'react-i18next'
import styles from './ClaimSearchCardView.module.scss'
import { Card, Grid, Spacer, Typography } from '@percent/lemonade'
import classNames from 'classnames/bind'

type ClaimSearchCardViewProps = {
  title: string
  subTitle: string
  detail: string
  cardAction: ReactNode
  alignCardToBottom?: boolean
}

const cx = classNames.bind(styles)

export function ClaimSearchCardView({
  title,
  subTitle,
  detail,
  cardAction,
  alignCardToBottom = true
}: ClaimSearchCardViewProps) {
  const { t } = useTranslation()

  return (
    <Card className={styles.cardContainer}>
      <Grid gutter={12} w="100%" p={12}>
        <Grid.Col span={{ xs: 6, md: 8 }}>
          <Typography variant="h3" color="secondary">
            {title}
          </Typography>
          <Spacer size={2} axis="vertical" />
          <Grid gutter={8}>
            <Grid.Col span={{ xs: 6, md: 2 }}>
              <Typography>{t('typography.address')}</Typography>
            </Grid.Col>
            <Grid.Col span={{ xs: 6, md: 10 }}>
              <Typography color="textSecondary">{subTitle}</Typography>
            </Grid.Col>
            <Grid.Col span={{ xs: 6, md: 2 }}>
              <Typography>{t('typography.registerNumber')}</Typography>
            </Grid.Col>
            <Grid.Col span={{ xs: 6, md: 10 }}>
              <Typography color="textSecondary">{detail}</Typography>
            </Grid.Col>
          </Grid>
        </Grid.Col>

        <Grid.Col
          span={{ xs: 6, md: 4 }}
          className={cx({
            buttonContainerTopAlignment: !alignCardToBottom,
            buttonContainerBottomAlignment: alignCardToBottom
          })}
          data-testid="card-action-wrapper"
        >
          {cardAction}
        </Grid.Col>
      </Grid>
    </Card>
  )
}
